import { useState } from 'react';
import axios, { AxiosResponse } from 'axios';
import { Routes } from '#config/routes';

const useNewsletterSignup = () => {
  const [error, setError] = useState<AxiosResponse | undefined>();
  const [success, setSuccess] = useState<AxiosResponse | undefined>();
  const [loading, setLoading] = useState(false);

  const reset = () => {
    setError(undefined);
    setSuccess(undefined);
    setLoading(false);
  };

  const submit = (email: string, locale: string) => {
    setLoading(true);
    setError(undefined);
    setSuccess(undefined);
    axios({
      method: 'post',
      url: Routes.NEWSLETTER_API,
      data: {
        locale,
        email,
      },
    })
      .then((res) => {
        setLoading(false);
        setSuccess(res);
      })
      .catch((err) => {
        setLoading(false);
        setError(err.response);
      });
  };

  return {
    error,
    success,
    loading,
    reset,
    submit,
  };
};

export default useNewsletterSignup;
